import { Card, Pagination } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import Utils from "../../../../utils/Utils";
import FGNoData from "./FGNoData";
import { ArrowUpRightIcon } from "lucide-react";

function FreeGuidesCardData({
  guideDataFlag,
  pageNumber,
  pageSize,
  pageCount,
  onPageChange,
  notFoundFlag,
  searchButtonText,
}) {
  const navigate = useNavigate();

  const handlePageChange = (page) => {
    onPageChange(page);
  };

  const handleViewGuideClick = (identifier, industryId, status) => {
    if (identifier !== "" && status === "Active") {
      navigate(`/prepareGuide/${identifier}?industryId=${industryId}`);
      // navigate(`/viewGuide/${identifier}?industryId=${industryId}`);
    }
  };

  return (
    <>
      {!notFoundFlag ? (
        <>
          <div className="mt-4 flex flex-col items-center">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-[.9rem] gap-x-[1.15rem] w-full">
              {guideDataFlag?.length > 0 &&
                guideDataFlag.map((item, index) => (
                  <Card
                    key={index}
                    className="w-full orange-card hover-effect driverjs-alljobs-individual-guide-card h-full"
                  >
                    <div className="flex flex-col justify-between gap-[.35rem] h-full">
                      <div className="flex flex-wrap gap-2 justify-between break-words">
                        <div className="flex-1">
                          <p className="text-[#101828] text-[1.12rem] font-bold leading-[1.5rem]">
                            {item?.jobTitle}
                          </p>
                        </div>
                        {/* <div className="w-[72px]">
                          <Image />
                        </div> */}
                      </div>
                      <p className="text-lightGreyish text-base mb-[.3rem] font-semibold text-[1.02rem] leading-[1.35rem]">
                        {item?.companyName}
                      </p>
                      <div className="flex flex-col gap-[.1rem]">
                        <div className="text-[#475467] font-medium text-[0.88rem]">
                          {item?.yearsOfExperience}+ years of experience
                        </div>
                        <div className="text-[#475467] font-medium text-[0.88rem]">
                          Created on{" "}
                          <strong>
                            {Utils.converToDateMonthYear(item?.creationTime)}
                          </strong>
                        </div>
                        <div className="text-[#475467] font-medium text-[0.88rem]">
                          {item?.jobLocation || "Location not specified"}
                        </div>
                      </div>
                      <div className="flex justify-end ">
                        <span
                          className="flex items-center gap-1 hover-effect text-amber-600 font-semibold hover:text-amber-500 transition-all duration-200 text-[0.9rem] cursor-pointer driverjs-all-guide-card-action-link"
                          onClick={() =>
                            handleViewGuideClick(
                              item.jobGuideIdentifier,
                              item.industryId,
                              item.guideStatus
                            )
                          }
                        >
                          View guide
                          <ArrowUpRightIcon
                            className="hover:text-amber-500"
                            size={20}
                            strokeWidth={2.5}
                            color="currentColor"
                          />
                        </span>
                      </div>
                    </div>
                  </Card>
                ))}
            </div>

            <Pagination
              className="mt-4"
              current={pageNumber + 1}
              pageSize={pageSize}
              total={pageCount}
              onChange={handlePageChange}
              showSizeChanger={false}
            />
          </div>
        </>
      ) : (
        <div className="mt-8 py-2">
          {searchButtonText ? (
            <FGNoData text="No matching free guides found." />
          ) : (
            <FGNoData
              text={
                "No guides are available in this industry right now. Please explore other domains."
              }
            />
          )}
        </div>
      )}
    </>
  );
}

export default FreeGuidesCardData;
